import i18next from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import { langTypes } from 'config/langType';
import getNavigatorLangForAdmin from 'utils/getNavigatorLangForAdmin';

const loadTranslations = async () => {
    const availableLanguages = ['zh-TW', 'en-US', 'ja'];
    const resources = {};

    const loadPromises = availableLanguages.map(async lang => {
        try {
            const translation = await import(`./${lang}.json`);
            return { lang, translation };
        } catch (error) {
            console.warn(`Failed to load translation for ${lang}:`, error);
            return { lang, translation: null };
        }
    });

    const translations = await Promise.all(loadPromises);

    translations.forEach(({ lang, translation }) => {
        resources[lang] = {
            translation: translation.default
        };
    });

    return resources;
};

const initializeI18n = async () => {
    const resources = await loadTranslations();

    i18next
        .use(ICU)
        .use(initReactI18next)
        .init({
            resources,
            lng: getNavigatorLangForAdmin(),
            fallbackLng: langTypes.ZH_TW,
            keySeparator: false,
            interpolation: {
                escapeValue: false // react already safes from xss
            }
        });
};

// Initialize i18n
initializeI18n();
